exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vsg-stack-item[data-v-58024546]{position:absolute;top:0;left:0}", ""]);

// exports
